import { $Qll, $Q } from '../utils/query-selector';
import { btnAddToCart } from "./cart";
import { dataToggle, toggleDataActive } from '../utils/toggle-dataset';
import {
  updateCartItems,
  updatetotalPrice,
  updateRecommended,
  updateUpsell,
  updateCartbutton,
  updatePriceItem,
  updateCartItem,
  updateCartQuantity,
  updateEmptyCart
} from './update-cart';
import { updateBarProgress } from '../utils/bar-progress';

export function initCustomerPortalSubscriptionInfos() {
  const userEmail = window.shopify_variables.customerEmail;
  let shopifyProducts = window.shopify_variables.products


  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
  var urlencoded = new URLSearchParams();
  urlencoded.append('email', userEmail);
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow',
  };

  fetch('https://jolly-render-services.onrender.com/anatae/loop', requestOptions)
    .then((response) => response.json())
    .then((resp) => {
      document.getElementById('jc-subscriptions-loader').dataset.active ='false';
      let userData = resp['userData'].data;
      let container = document.getElementById('loop-result');

      container.innerHTML = '';

      const allSubscriptionsInactive = userData.subscriptions.every(
        (subscription) => subscription.status !== 'ACTIVE'
      );
      if (allSubscriptionsInactive) {
        container.innerHTML = `<div class="jc-text-center jc-py-10 jc-text-xl lg:jc-text-3xl"> ${window.shopify_variables.translations.subscriptions.no_subscriptions}</div>`;
        return;
      }

      userData.subscriptions
        .filter((s) => s.status && s.status == 'ACTIVE')
        .forEach((result, i) => {
          const resultDiv = document.createElement('div');
          const resultItems = document.createElement('div');
          resultDiv.id = 'cp_subscription_id-' + i;
          resultItems.id = 'cp_subscription-item_id-' + i;

          const formattedDate = new Date(
            result.next_billing_date
          ).toLocaleDateString('fr-FR', {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          });

          result.line_items.forEach((line_item) => {
            let img = '';
            let options = '';

            const targetProductId = line_item.product_shopify_id;
            const targetProduct = shopifyProducts.find(
              (product) => product.id === targetProductId
            );

            if (targetProduct) {
              img = targetProduct.featured_image;

              const targetVariantId = line_item.variant_shopify_id;
              const targetVariant = targetProduct.variants.find(
                (variant) => variant.id === targetVariantId
              );

              if (targetVariant && targetVariant.options) {
                options =
                  '<div class="jc-my-1 jc-text-base">' +
                  targetVariant.options +
                  '</div>';
              }

              if (
                targetVariant &&
                targetVariant.featured_image &&
                targetVariant.featured_image.src != ''
              ) {
                img = targetVariant.featured_image.src;
              }
            }

            let items = `<div class="jc-py-4 jc-border-t jc-border-0 jc-border-solid jc-border-chinesewhite jc-flex jc-gap-4">
                      <div class="jc-shrink-0">
                        <img src="${img}" width="80" height="80" class="jc-w-20 jc-block jc-h-20 jc-rounded-[10px]">
                      </div>
                      <div class="jc-flex jc-flex-col">
                        <div class="jc-text-md jc-uppercase jc-font-semibold jc-font-[Rubik]">${line_item.name}</div>
                        ${options}
                        <div class="jc-mt-auto">${line_item.subscription_price_display} x ${line_item.quantity}</div>
                      </div>
                    </div>`;

            resultItems.innerHTML += items;
          });

          if (result.status && result.status == 'ACTIVE') {

            resultDiv.innerHTML = `<div class="jc-bg-white jc-p-4 jc-border jc-border-solid jc-border-chinesewhite jc-rounded-[10px] jc-mt-4">
                    <div class="jc-flex max-md:jc-flex-col jc-gap-4 md:jc-items-center jc-mb-4">
                      <div id="cp_subscription_id-0" class="jc-text-granitegray">#${result.subscription_shopify_id}</div>
                      <div class="jc-inline-flex jc-items-center jc-gap-1.5 jc-ml-auto jc-uppercase
                        jc-py-1 jc-px-2 jc-font-semibold jc-rounded-[4px] jc-font-[Rubik] jc-text-sm
                        jc-text-cadmiumgreen jc-bg-dirtywhite before:jc-bg-cadmiumgreen
                        before:jc-w-1 before:jc-h-1 before:jc-rounded-full before:jc-content-['']">
                        ${window.shopify_variables.translations.subscriptions.ACTIVE}
                      </div>
                    </div>

                    <div class="md:jc-flex-row jc-flex jc-flex-col jc-gap-4 jc-mb-4">
                      <div class="jc-flex jc-gap-1 jc-text-md">${window.shopify_variables.translations.subscriptions.next_order} : <span class="jc-font-bold">${formattedDate}</span></div>
                      <div class="jc-flex jc-gap-1 jc-text-md">${window.shopify_variables.translations.subscriptions.delivery_every}<span class="jc-font-bold">${result.delivery_interval_count > 1 ? result.delivery_interval_count : ""} ${shopify_variables.translations.custom.month}</span></div>
                    </div>

                    <!-- orders list -->
                    ${resultItems.innerHTML}
                    <!-- end orders list -->

                    <div class="jc-subscriptions-list-footer jc-flex jc-items-center jc-pt-4 jc-border-t jc-border-0 jc-border-solid jc-border-chinesewhite">
                      <span><b>${result.total_line_item_price_display}</b> + ${result.shipping_price_display} ${window.shopify_variables.translations.customer.account.shipping}</span>
                      <a href="/a/loop_subscriptions/customer/${userData.customer_shopify_id}/subscription/${result.subscription_shopify_id}?" class="jc-ml-auto jc-no-underline jc-inline-flex jc-text-cadmiumgreen jc-items-center jc-gap-1">
                        ${window.shopify_variables.translations.subscriptions.details}
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M7.5 15.0001L12.5 10.0001L7.5 5.00006" stroke="#00602C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg></a>
                    </div>
                  </div>`;
          }

          container.appendChild(resultDiv);
        });
    })
    .catch((err) => console.error(err));

  document.addEventListener('DOMContentLoaded', (event) => {
    let loopRedirectButton = document.getElementById(
      'jc_loop_subscriptions_redirect'
    );

    loopRedirectButton.addEventListener('click', (e) => {
      e.preventDefault();
      localStorage.setItem('redirect_from_profile', '1');
      const href = e.currentTarget.href;
      window.location.href = href;
    });
  });
} 

export async function repeatOrder() {
 const repeatOrderBtn = $Q('.jc-order-repeat');

 const orderItems = $Qll('.jc-orders-item');
 const updates = {};

 repeatOrderBtn.addEventListener('click', async (e) => {
 

  orderItems.forEach(item => {
    let variantId = Number(item.dataset.variantId);
    let quantity = Number(item.dataset.quantity);

    updates[variantId] = quantity;
  })

  let formData = {
    updates: updates,
    sections: ['cart']
  };

  const updateData = await updateProducts(formData);

  if (updateData) {

  }
 })
}

async function updateProducts(updates) {
  try {
    const response = await fetch(`${window.location.origin}/cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updates)
    });

    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const data = await response.json();
    const parser = new DOMParser();
   
    const productFetchedSectionHTML = data.sections['cart'];
 
   
    updateEmptyCart(productFetchedSectionHTML);
    updateCartItems(productFetchedSectionHTML);
    updateCartbutton(productFetchedSectionHTML);
    updatetotalPrice(productFetchedSectionHTML);
    updateUpsell(productFetchedSectionHTML);
    updateCartQuantity(productFetchedSectionHTML);
    updateBarProgress(productFetchedSectionHTML);

    dataToggle($Q('.js-cart'), true);
 
    return data;
  } catch (error) {
    console.error('Error in updateProducts:', error);
    throw error;
  }
}